import { render, staticRenderFns } from "./PopupCreate891.vue?vue&type=template&id=283bde49&scoped=true"
import script from "./PopupCreate891.vue?vue&type=script&lang=js"
export * from "./PopupCreate891.vue?vue&type=script&lang=js"
import style0 from "./PopupCreate891.vue?vue&type=style&index=0&id=283bde49&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283bde49",
  null
  
)

export default component.exports